<template>
  <div class="full-height">
    <foobar-header></foobar-header>
    <intro></intro>
    <section-intro :title="$t('message.title.main.foobar_beer')"></section-intro>
    <foobar :foobar-id="$route.params.id"></foobar>
    <foobar-footer></foobar-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import FoobarHeader from '@/components/partials/Header'
  import FoobarFooter from '@/components/partials/Footer'
  import Foobar from '@/components/foobar/Foobar'
  import SectionIntro from '@/components/partials/SectionIntroZeroOne'

  export default {
    components: {
      Intro,
      FoobarFooter,
      FoobarHeader,
      Foobar,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// Foobar.vue?686a0ece